import { FormEvent, useEffect, useState } from 'react';
import { Button, Col, Form, Row, Stack } from 'react-bootstrap';
import CustomFormInput from '../../components/CustomFormInput';
import useAPIError from '../../hooks/apiError.context';
import classNames from 'classnames';
import './style.scss';
import useAuth from '../../hooks/auth.hook';

const PasswordRecovery = () => {
  const initialTimer = 5;
  const auth = useAuth();
  const apiError = useAPIError();
  const [validated, setValidated] = useState(false);
  const [email, setEmail] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [timer, setTimer] = useState(initialTimer);
  const [attemps, setAttemps] = useState(0);

  const messageClassName = classNames({
    'text-center': !showMessage
  });

  const sendEmailClassName = classNames('resend-email text-primary px-3', {
    disabled: timer >= 0
  });

  useEffect(() => {
    setTimer(initialTimer * 3 ** attemps);

    const interval = setInterval(() => {
      setTimer((oldTimer) => oldTimer - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [attemps]);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const form = event.currentTarget;
    const isFormValid = form.checkValidity();

    if (!isFormValid) {
      setValidated(true);
      return;
    }

    try {
      await auth.recoveryPassword(email);
      setShowMessage(true);
    } catch (err) {
      apiError.showError(err as Error);
      setValidated(false);
    }
  };

  const handleResendClick = async () => {
    if (timer < 0) {
      try {
        await auth.recoveryPassword(email);
        setAttemps((oldValue) => oldValue + 1);
      } catch (err) {
        apiError.showError(err as Error);
      }
    }
  };

  const title = showMessage ? 'Revisa tu email' : 'Recuperar contraseña';
  const message = showMessage
    ? 'Se ha enviado un correo con las instrucciones para restablecer tu contraseña.'
    : 'Ingresa el correo electrónico asociado con tu cuenta.';

  return (
    <Stack gap={1} className="recovery-password py-3 pb-4">
      <div className=" px-3">
        <h4 className="text-primary text-center">{title}</h4>
        <div className={messageClassName}>
          <span>{message}</span>
          {showMessage ? (
            <>
              <br />
              <span>Si no aparece en tu bandeja de entrada, verifica tu carpeta de spam.</span>
            </>
          ) : null}
        </div>
      </div>
      {showMessage ? (
        <div className={sendEmailClassName} onClick={handleResendClick}>
          Reenviar correo {timer < 0 ? null : `(${timer}s)`}
        </div>
      ) : (
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row className="justify-content-around">
            <Col xs={9}>
              <CustomFormInput
                type="email"
                placeholder="Correo electrónico"
                feedback="Ingrese un correo electrónico válido."
                value={email}
                onChange={(ev) => setEmail(ev.target.value)}
                required
              />
            </Col>
          </Row>
          <br />
          <Row className="justify-content-around">
            <Col className="d-flex align-items-center" xs={10} md={6}>
              <Button type="submit" className="w-100">
                Enviar
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Stack>
  );
};

export default PasswordRecovery;
